export const api_url = 'https://tasksapi.arttteo.com/api'
// export const api_url = 'http://localhost:8000/api'


export const AXIOS_HEADER = {
    headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('auth_token')
    }
}